import styled from "styled-components";

export const Card = styled.div`
  width: 18.875rem;
  height: 10.375rem;
  border-radius: 0.5rem;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 0px 0px 27.2px 0px rgba(163, 163, 163, 0.25);
  padding: 0.5em;
  position: relative;
  margin-bottom: 2.5em;
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    /* justify-content: space-evenly; */
    width: 16rem;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    height: 10.375rem;
  }
`;
export const Status = styled.div`
  position: absolute;
  top: 1em;
  left: 1em;
  width: 5.875rem;
  height: 1.6875rem;
  border-radius: 0.625rem;
  border: 1px solid;
  border-color: ${(props: any) => (props.status === "Done" ? "#86DEA4" : " #F6FFF9")};
  color: ${(props: any) => (props.status === "Done" ? "#86DEA4" : " #363636")};
  background: #fff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Poppins;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    width: 4.875rem;
    height: 1.6875rem;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 5.875rem;
    height: 1.6875rem;
  }
`;
export const Edit = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  position: absolute;
  right: 1.69em;
  top: 0.88em;
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    right: 1em;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    right: 1.69em;
  }
`;
export const IconImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
export const Icon = styled.div`
  width: 3.75rem;
  height: 3.75rem;
  margin: 0 auto;
  /* margin-top: -0.66em; */
  justify-content: center;
  align-items: center;
  display: flex;
`;
export const Description = styled.div`
  width: 9.4375rem;
  color: #351182;
  text-align: center;
  font-family: Poppins;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0 auto;
  margin-top: 0.81em;
`;
